export function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export function onFullyLoaded(fn) {
    window.addEventListener('load', () => {
        fn();
    });
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}

export function getParams(url = window.location) {
    const params = {};

    new URL(url).searchParams.forEach(function (val, key) {
        // eslint-disable-next-line no-negated-condition
        if (params[key] !== undefined) {
            if (!Array.isArray(params[key])) {
                params[key] = [params[key]];
            }
            params[key].push(val);
        } else {
            params[key] = val;
        }
    });

    return params;
}
